import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//#region MUI
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
//#endregion
import {css} from '../../../constants';
export function getColorHeader(theme) {
   return theme.palette.primary.light;
}
const useStyles = makeStyles((theme) => {
   const colorHeader = getColorHeader(theme);
   return {
      root: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'start'
      },
      fullWidth: {
         width: '100%'
      },
      titleContainer: {
         backgroundColor: colorHeader,
         padding: theme.spacing(1)
      },
      contentContainer: {
         width: '100%',
         flexGrow: 1,
         overflow: 'scroll',
         display: 'block',
         borderStyle: 'solid',
         borderWidth: 1,
         borderColor: colorHeader,
         overflowX: 'hidden',
         overFlowY: 'scroll'
      },
      buttonsContainer: {
         backgroundColor: colorHeader
      },
      buttonNegativo: {
         backgroundColor: 'red'
      },
      buttonSubmit: {
         backgroundColor: 'green'
      }
   };
});
const defaultLabels = {
   titulo: 'titulo default',
   submit: 'submit',
   cancelar: 'cancelar',
   negativo: 'negativo'
};
function SimpleFormContainer({
   children,
   labels: labelsInProps,
   onSubmitClick,
   onCancelarClick,
   onNegativoClick,
   classNameTitulo,
   classNameProcesar,
   classNameCancelar,
   classnameNegativo,
   tituloProps,
   submitButtonProps,
   cancelarButtonProps,
   negativoButtonProps,
   extraActions,
   extraActionContainerClassName
}) {
   const labels = {...defaultLabels, ...labelsInProps};
   const classes = useStyles();
   function handleSubmitForm(e) {
      if (typeof onSubmitClick === 'function') {
         onSubmitClick(e);
      }
   }
   const XtraActions = (
      <div className={extraActionContainerClassName} style={{flexGrow: 1}}>
         {extraActions}
      </div>
   );
   const nroAcciones =
      (onCancelarClick ? 1 : 0) + (onNegativoClick ? 1 : 0) + (onSubmitClick ? 1 : 0);
   const gridXsSize = 12 / (nroAcciones === 0 ? 1 : nroAcciones);
   return (
      <Container className={clsx(css.DS_CONTAINERBOX)} maxWidth="md" style={{height: '100%'}}>
         <div className={clsx(css.DS_FULLSIZE, classes.root)}>
            <div className={clsx(classes.fullWidth, classes.titleContainer)}>
               <Typography variant="h2" {...tituloProps} className={classNameTitulo}>
                  {labels.titulo}
               </Typography>
            </div>
            <div className={classes.contentContainer}>
               <div className={css.DS_FULLSIZE}>{children}</div>
            </div>
            <Grid container className={classes.buttonsContainer} spacing={1}>
               {onCancelarClick && (
                  <Grid item xs={gridXsSize} sm={2}>
                     <Button
                        variant="contained"
                        {...cancelarButtonProps}
                        className={classNameCancelar}
                        onClick={onCancelarClick}
                        fullWidth
                     >
                        {labels.cancelar}
                     </Button>
                  </Grid>
               )}
               {onNegativoClick && (
                  <Grid item xs={gridXsSize} sm={2}>
                     <Button
                        variant="contained"
                        color="primary"
                        {...negativoButtonProps}
                        className={clsx(classes.buttonNegativo, classnameNegativo)}
                        onClick={onNegativoClick}
                        fullWidth
                     >
                        {labels.negativo}
                     </Button>
                  </Grid>
               )}
               <Hidden xsDown>{XtraActions}</Hidden>
               {onSubmitClick && (
                  <Grid item xs={gridXsSize} sm={2}>
                     <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        {...submitButtonProps}
                        className={clsx(classes.buttonSubmit, classNameProcesar)}
                        fullWidth
                        onClick={handleSubmitForm}
                     >
                        {labels.submit}
                     </Button>
                  </Grid>
               )}
               <Hidden smUp>
                  <Grid item container xs={12}>
                     {XtraActions}
                  </Grid>
               </Hidden>
            </Grid>
         </div>
      </Container>
   );
}
SimpleFormContainer.propTypes = {
   labels: PropTypes.shape({
      titulo: PropTypes.string,
      submit: PropTypes.string,
      cancelar: PropTypes.string,
      negativo: PropTypes.string
   }),
   onSubmitClick: PropTypes.func,
   onCancelarClick: PropTypes.func,
   onNegativoClick: PropTypes.func,
   classNameTitulo: PropTypes.string,
   classNameProcesar: PropTypes.string,
   classNameCancelar: PropTypes.string,
   classnameNegativo: PropTypes.string,
   /**
    * [Typography props](https://v4.mui.com/api/typography/#typography-api "Material UI Typography API")
    */
   tituloProps: PropTypes.object,
   /**
    * [Button props](https://v4.mui.com/api/button/#button-api "Material UI Button API")
    */
   submitButtonProps: PropTypes.object,
   /**
    * [Button props](https://v4.mui.com/api/button/#button-api "Material UI Button API")
    */
   cancelarButtonProps: PropTypes.object,
   /**
    * [Button props](https://v4.mui.com/api/button/#button-api "Material UI Button API")
    */
   negativoButtonProps: PropTypes.object,
   extraActions: PropTypes.node
};
SimpleFormContainer.defaultProps = {
   labels: defaultLabels
};
export default SimpleFormContainer;
